export class JsonItem {
    Id: string;
    Json: any;
}

export class PickListItem {
    Id: number;
    Value: string;
}

export class PickListItemSorted {
    Id: number;
    Value: string;
    SortOrder: number;
}

export class PickListItemString {
    Id: string;
    Value: string;
}

// For Edit/Add
export class SavePickListOption {
    pickListName: string;
    optionId: number;
    optionValue: string;
}

export class SavePickListSortedOption {
    pickListName: string;
    optionId: number;
    optionValue: string;
    sortOrder: number;
}